/**
 * @generated SignedSource<<48242a043723a47c0507b317aa640a69>>
 * @relayHash f9bb43f6abe4afa1efe38b263fecef29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f2f975f48898f550217e6f70f97d058bae26f3b82201365111f6938e585dcde

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { notificationTableQuery } from './notificationTableQuery.graphql';

const node: PreloadableConcreteRequest<notificationTableQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4f2f975f48898f550217e6f70f97d058bae26f3b82201365111f6938e585dcde",
    "metadata": {},
    "name": "notificationTableQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
